module.exports = require('./helpers/bundle-url').getBundleURL('c9iqF') + "subout.4dd1a837.png";